import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ConfirmationModal from '../common/ConfirmationModal';
import { closeUrl } from '../common/appUrlActionCreators';
import { confirmPlacement } from '../common/CustomModal';

const AppUrl = (props) => {
    if (!props.url) {
        return null;
    }

    const openUrl = () => {
        window.open(props.url);
        props.dispatchCloseUrl();
    };

    return (
        <ConfirmationModal
            className="ast-app-url"
            confirmLabel="Go to external site"
            closeHandler={props.dispatchCloseUrl}
            title={<img className="ast-app-url__logo" src={props.appLogo} />}
            subTitle={
                <div className="ast-app-url__subtitle sg-modal-title">
                    You need to enable this integration
                    <br />
                    from an external site
                </div>
            }
            confirmHandler={openUrl}
            confirmPlacement={confirmPlacement.sideNote}
        >
            <p className="ast-app-url__description">
                This integration is available from an external site. From there, you can learn how to enable the
                integration and how to get started.
            </p>
        </ConfirmationModal>
    );
};

AppUrl.propTypes = {
    name: PropTypes.string,
    url: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    dispatchCloseUrl: PropTypes.func,
    appLogo: PropTypes.string,
};

const mapStateToProps = (state) => {
    const foundApp = state.appsList.apps.find(({ appId }) => appId === state.appUrl.appId);

    return { ...state.appUrl, appLogo: foundApp && foundApp.appLogo };
};

const mapDispatchToProps = {
    dispatchCloseUrl: closeUrl,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppUrl);
